<template lang="html">
    <div id="groups" class="center-panel">
        <md-content md-theme="white" v-loader-overlay="progress">
            <user-menu></user-menu>
            <sort-table 
                v-bind:columns="tableColumns" :table-id="'users-groups-list'" v-model="groups" v-on:refresh="getUserGroups" 
                v-bind:per-page="perPage" v-bind:total="groupsAmount" v-on:create="addGroup" tableHeight="calc(100% - 48px)" link
            >
                <template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" v-on:click.stop.prevent="onRemove(scope.item.id)" danger-light rounded></z-icon-button>
                </template>
            </sort-table>
        </md-content>
    </div>
</template>
<script>
    import UserMenu    from './menu.vue';
    import SortTable   from "@/components/SortTable";
    import ZIconButton from '@/components/ZIconButton.vue';
    export default {
        components: {UserMenu, SortTable, ZIconButton},
        data() {
            return {
                tableColumns: [
                    { label: 'ID', field: 'id', default: true, sortable: true },
                    { label: 'Символьный код', field: 'code', sortable: true },
                    { label: 'Название', field: 'name', sortable: true },
                    { label: '', field: 'actions' },
                ],
                title: 'Группы пользователей',
                perPage: 50
            }
        },
        watch: {
            '$route.name'() {
                if (this.$route.name == 'UserGroups')
                    this.$store.commit('setTitle', this.title);
            }
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             * @returns Boolean
             */
            progress() {
                return this.progressObj['get-users-groups-list'];
            },
            /**
             * Объект с флагами загрузи
             * @returns Object
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
            /**
             * Список групп пользователей
             */
            groups() {
                return this.$store.state.users.groups.map(group => {
                    group.routerLink = {name: 'UserGroup', params: {group_code: group.code}, query: this.$route.query}
                    return group
                });
            },
            /**
             * Количество групп пользователей
             */
            groupsAmount() {
                return this.$store.state.users.groups_amount;
            },
        },
        created() {
            this.$store.commit('setTitle', this.title);
            this.$root.$emit('reload-table', 'users-groups-list');
        },
        methods: {
            /**
             * Добавление группы
             */
            addGroup() {
                this.$router.push({ name: 'UserGroup', params: {group_code: 'new'} });
            },
            /**
             * Получение групп пользователей
             */
            getUserGroups(page, count, orderBy, orderType) {
                this.$store.commit('showProgressBar', 'get-users-groups-list');
                this.$store.dispatch('users/getUsersGroups', {page: page, order_by: orderBy, order_type: orderType, count: count})
                    .finally(() =>  this.$store.commit('hideProgressBar', 'get-users-groups-list'));
            },
            /**
             * Удаление группы пользователей
             */
            removeGroup(id) {
                if (!id) return;
                this.$store.commit('showProgressBar', 'get-users-groups-list');
                this.$store.dispatch('users/removeGroup', id)
                    .then(() => this.$root.$emit('refresh-table', 'users-groups-list'))
                    .finally(() => this.$store.commit('hideProgressBar', 'get-users-groups-list'));
            },
            /**
             * Модальное окно с подтверждением удаления группы
             */
            onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении группы', 'Действие необратимо!',
                    () => this.removeGroup(id)
                );
            }
        }
    }
</script>
<style lang="sass"></style>


// WEBPACK FOOTER //
// Groups.vue?97fcd262